import { render, staticRenderFns } from "./DocumentTemplateDetailCard.vue?vue&type=template&id=0ad2e675"
import script from "./DocumentTemplateDetailCard.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports